import Miscellaneous from './Miscellaneous';

export default Miscellaneous;
